import {AuthorizationLevel} from '@igp/shared/auth';
import type {UserManagerSettings} from 'oidc-client-ts';

type UserManagerSettingsParams = {
    authUrl: string;
    clientId: string;
    silentRefreshPage: string;
};

export function getUserManagerSettings({authUrl, clientId, silentRefreshPage}: UserManagerSettingsParams): UserManagerSettings {
    const clientUrl = location.origin;

    return {
        authority: authUrl,
        client_id: clientId,
        redirect_uri: clientUrl,
        post_logout_redirect_uri: clientUrl,
        response_type: 'code',
        scope: 'openid profile',
        acr_values: AuthorizationLevel.Password,
        filterProtocolClaims: ['nbf', 'jti', 'nonce', 'amr', 'azp', 'at_hash'],
        loadUserInfo: true,
        silent_redirect_uri: `${clientUrl}/${silentRefreshPage}`,
        accessTokenExpiringNotificationTimeInSeconds: 300,
    };
}
